import { api } from "@/api"

type SendOrderReceiptRequest = {
  email?: string
  sms?: string
}

export const sendOrderReceipt = async (
  orderId: string,
  params: SendOrderReceiptRequest
) => {
  await api.post(`/orders/${orderId}/send-receipt/`, {
    body: params,
  })
}
